/**
 * Design-Tokens als semantische Rollen (nicht Marken-Farben).
 * Werte sind "R G B" (durch Leerzeichen getrennt) — passend zu
 *   rgb(var(--color-x) / <alpha-value>)
 * in der Tailwind-Konfiguration.
 *
 * WICHTIG: Farbwerte gehören ausschließlich hierher bzw. in base.css.
 * Niemals feste Hex-Werte in Komponenten. Pro Mandant überschreibbar
 * (siehe buildThemeCss / organization_branding.accent_color).
 *
 * Mavatech CRM hat nur ein helles Theme. base.css muss mit diesen Werten
 * synchron gehalten werden.
 */

export type TokenMap = Record<string, string>

export const lightTokens: TokenMap = {
  'color-bg-primary': '255 255 255',
  'color-bg-secondary': '247 247 249',
  'color-bg-tertiary': '239 239 243',
  'color-bg-card': '255 255 255',
  'color-bg-hover': '242 242 245',
  'color-bg-active': '231 231 236',
  'color-bg-input': '255 255 255',

  // Seitenleiste: dunkles, gedämpftes Mavatech-Blau mit heller Schrift (pro Mandant überschreibbar).
  'color-sidebar-bg': '20 43 58',
  'color-sidebar-hover': '30 58 78',
  'color-sidebar-border': '42 72 94',
  'color-sidebar-text': '219 228 237',
  'color-sidebar-text-muted': '142 163 182',

  'color-border-subtle': '236 236 240',
  'color-border-default': '222 222 229',
  'color-border-strong': '198 198 208',

  'color-text-primary': '22 22 26',
  'color-text-secondary': '85 85 106',
  'color-text-tertiary': '138 138 156',
  'color-text-inverse': '255 255 255',

  'color-accent': '43 135 199',
  'color-accent-hover': '33 111 166',

  'color-success': '34 197 94',
  'color-warning': '245 158 11',
  'color-danger': '239 68 68',
  'color-purple': '168 85 247',
}

/** Hex (#rrggbb) → "R G B"; ungültige Eingabe → null. */
export function hexToRgbTriplet(hex: string): string | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m || !m[1]) return null
  const int = Number.parseInt(m[1], 16)
  return `${(int >> 16) & 255} ${(int >> 8) & 255} ${int & 255}`
}
